import { Blac } from "blac-next";
import { diagnosticsSessionId } from "src/lib/diagnosticsSession";
import { logSentryEvent } from "src/lib/logSentryEvent";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import type { TrackingData } from "src/state/Track/TrackCubit";
import { tracker } from "src/state/state";

export const isPartnerDiagnosticsEnabled = (): boolean =>
  Boolean(Blac.getBloc(AppViewCubit).state.partnerSession);

export const trackPartnerDiagnostic = (
  event: string,
  data: TrackingData = {}
): void => {
  if (!isPartnerDiagnosticsEnabled()) {
    return;
  }
  const payload = { ...data, sessionId: diagnosticsSessionId };
  tracker.track(event, { data: payload });
  logSentryEvent(event, payload);
};
